import {createStateMaker} from '@shared/helpers/object'

import {ExpenseDetailsState} from '../interfaces'

export const getInitialState = (): ExpenseDetailsState => {
    return {
        name: '',
        /** 상품 개수 */
        count: 0,
        /** 세부상품 정보 */
        items: [],
        /** 전체 부과된 가격 */
        price: 0,
        /** 실제 결제 예정 금액 */
        priceToBePaid: 0,
        /** 결제 정보내역 설명 */
        description: null,
        /** 결제 정보 이미지 */
        imageUrl: null,
        /** 서비스 체널 정보 */
        serviceChannel: {
            type: '',
            name: '',
        },
        /** 빌링 분류 정보 */
        billing: null,
        /** 다음 결제 예정 정보 */
        nextPayment: null,
        /** 결제관련 추가정보 */
        extra: null,
    }
}

export const makeMock = createStateMaker<ExpenseDetailsState>(getInitialState)
